var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errorInfo && _vm.errorInfo.msg)?_c('div',{staticClass:"posi-fixed modelErrMsg-box"},[(_vm.errorInfo.type == 'fail')?_c('P',[_c('img',{attrs:{"src":require("../../assets/img/fail.png")}})]):_c('P',[_c('img',{attrs:{"src":require("../../assets/img/success.png")}})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.errorInfo.msg))])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c243c6e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/publicCpts/modelErrMsgCpt.vue
// module id = null
// module chunks = 